import { Component, inject, input, output, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { ModalCardComponent } from '@components/Modals/modal-card/modal-card.component';
import { SvgComponent } from '@components/svg.component';

@Component({
  selector: 'app-modal-force-reason',
  standalone: true,
  imports: [ReactiveFormsModule, ModalCardComponent, SvgComponent],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './modal-force-reason.component.html',
})
export class ModalForceReasonComponent {
  #fb = inject(FormBuilder);

  title = input.required<string>();
  subtitle = input<string | null>(null);
  reasonLabel = input.required<string>();
  reasonPlaceholder = input<string | null>(null);
  requiredErrorMessage = input<string | null>(null);
  cancelLabel = input.required<string>();
  confirmLabel = input.required<string>();

  cancelClick = output<void>();
  confirmClick = output<string>();

  form = this.#fb.nonNullable.group({
    reason: ['', Validators.required],
  });

  onConfirm(): void {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    this.confirmClick.emit(this.form.controls.reason.value);
  }
}
